var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    fill: "#D8D8D8",
    d: "M0 0h24v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "info",
    stroke: "none",
    strokeWidth: 1,
    fill: "#02BD9C",
    fillRule: "evenodd",
    className: "default",
    d: "M12 23c6.065 0 11-4.935 11-11S18.065 1 12 1 1 5.935 1 12s4.935 11 11 11zm0-23c6.617 0 12 5.383 12 12s-5.383 12-12 12S0 18.617 0 12 5.383 0 12 0zm0 10c.553 0 1 .503 1 1.125v6.75c0 .622-.447 1.125-1 1.125-.553 0-1-.503-1-1.125v-6.75c0-.622.447-1.125 1-1.125zm0-5c-.83 0-1.503.672-1.503 1.5S11.17 8 12 8c.83 0 1.503-.672 1.503-1.5S12.83 5 12 5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "info-selected",
    stroke: "none",
    strokeWidth: 1,
    fill: "#02BD9C",
    fillRule: "evenodd",
    className: "alt",
    d: "M12 5c.83 0 1.503.672 1.503 1.5S12.83 8 12 8c-.83 0-1.503-.672-1.503-1.5S11.17 5 12 5zm1 12.875c0 .622-.447 1.125-1 1.125-.553 0-1-.503-1-1.125v-6.75c0-.622.447-1.125 1-1.125.553 0 1 .503 1 1.125v6.75zM12 24c6.617 0 12-5.383 12-12S18.617 0 12 0 0 5.383 0 12s5.383 12 12 12z"
  })));
}
SvgInfo.displayName = 'Info';
export default SvgInfo;